import { useEffect, useState } from 'react';
import { Badge } from '../ui/badge';
import { nominationAPI } from '../../lib/atoNominationAPI';

export const NominationSummary = ({ clientId, compact }) => {
  const [s, setS] = useState(null);
  useEffect(() => { if (clientId) nominationAPI.summary(clientId).then(setS).catch(() => setS(null)); }, [clientId]);
  if (!s || !s.nomination) return null;
  if (compact) return s.sub_status ? <Badge className="bg-amber-100 text-amber-800" data-testid="ato-nomination-substatus">{s.sub_status}</Badge> : null;
  return (
    <div className="text-sm flex flex-wrap gap-x-4 gap-y-1" data-testid="ato-nomination-summary">
      <span>ATO Nomination: <b data-testid="ato-nomination-line">{s.nomination}</b></span>
      <span>Agent Linking: <b data-testid="ato-linking-line">{s.linking}</b></span>
      {s.sub_status && <Badge className="bg-amber-100 text-amber-800">{s.sub_status}</Badge>}
      <span className="text-xs text-muted-foreground">(does not block onboarding completion)</span>
    </div>
  );
};
